import { IMessageReactions } from 'Models/MessageModel';
import { useCallback } from 'react';
import { useToggleReactionMutation } from '../../requests';
import { markUserInitiatedReaction } from '../../utils/userReactionTracker';

/**
 * useReactionHandler - Custom hook for handling emoji reaction interactions
 *
 * This hook encapsulates the logic for toggling emoji reactions on messages.
 * It determines whether the current user has already reacted with a specific emoji
 * and calls the appropriate mutation to add or remove the reaction.
 */
export const useReactionHandler = (
  reactions: IMessageReactions | undefined,
  currentUserId: string,
  conversationId: string,
  messageId: string
) => {
  const toggleReaction = useToggleReactionMutation();

  const handleReactionClick = useCallback(
    (emoji: string) => {
      const hasReaction = reactions?.[emoji]?.includes(currentUserId) || false;

      markUserInitiatedReaction();

      toggleReaction.mutate({
        conversationId,
        messageId,
        emoji,
        hasReaction,
      });
    },
    [reactions, currentUserId, conversationId, messageId, toggleReaction]
  );

  return handleReactionClick;
};
